// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------------------------
   🔹 استایل دکمه اوت‌لاین (Outline)
   ----------------------------------------- */
.outline-button {
    background: transparent;          /* پس‌زمینه شفاف */
    border: 2px solid #EA6C22;        /* رنگ دور (قابل تغییر) */
    color: #EA6C22;                   /* رنگ متن هم‌خوان با دور */
    padding: 15px;
    border-radius: 15px;
    font-size: 15px;
    cursor: pointer;
    margin-top: 20px;
    transition: all 0.2s ease;
    display: inline-flex;
    justify-content: center;          /* افقی وسط */
    align-items: center;              /* عمودی وسط */
    gap: 0.5em;
}

/* حالت هاور: پر شدن پس‌زمینه */
.outline-button:hover:not(:disabled) {
    background: #EA6C22;
    color: #fff;
}

/* حالت غیرفعال */
.outline-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* حالت لودینگ */
.outline-button.is-loading {
    position: relative;
    pointer-events: none;
}

/* آیکن و متن */
.outline-button .btn-icon {
    display: flex;
}
.outline-button .btn-title {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/OutlineButton/OutlineButton.css"],"names":[],"mappings":"AAAA;;8CAE8C;AAC9C;IACI,uBAAuB,WAAW,kBAAkB;IACpD,yBAAyB,SAAS,yBAAyB;IAC3D,cAAc,oBAAoB,2BAA2B;IAC7D,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB,WAAW,aAAa;IAC/C,mBAAmB,eAAe,cAAc;IAChD,UAAU;AACd;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB","sourcesContent":["/* -----------------------------------------\n   🔹 استایل دکمه اوت‌لاین (Outline)\n   ----------------------------------------- */\n.outline-button {\n    background: transparent;          /* پس‌زمینه شفاف */\n    border: 2px solid #EA6C22;        /* رنگ دور (قابل تغییر) */\n    color: #EA6C22;                   /* رنگ متن هم‌خوان با دور */\n    padding: 15px;\n    border-radius: 15px;\n    font-size: 15px;\n    cursor: pointer;\n    margin-top: 20px;\n    transition: all 0.2s ease;\n    display: inline-flex;\n    justify-content: center;          /* افقی وسط */\n    align-items: center;              /* عمودی وسط */\n    gap: 0.5em;\n}\n\n/* حالت هاور: پر شدن پس‌زمینه */\n.outline-button:hover:not(:disabled) {\n    background: #EA6C22;\n    color: #fff;\n}\n\n/* حالت غیرفعال */\n.outline-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* حالت لودینگ */\n.outline-button.is-loading {\n    position: relative;\n    pointer-events: none;\n}\n\n/* آیکن و متن */\n.outline-button .btn-icon {\n    display: flex;\n}\n.outline-button .btn-title {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
